/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecoveryGrant interface.
 */
export function instanceOfRecoveryGrant(value) {
    if (!('grantId' in value) || value['grantId'] === undefined)
        return false;
    return true;
}
export function RecoveryGrantFromJSON(json) {
    return RecoveryGrantFromJSONTyped(json, false);
}
export function RecoveryGrantFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'grantId': json['grant_id'],
    };
}
export function RecoveryGrantToJSON(json) {
    return RecoveryGrantToJSONTyped(json, false);
}
export function RecoveryGrantToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'grant_id': value['grantId'],
    };
}
